import { render, staticRenderFns } from "./MassMessageStatView.vue?vue&type=template&id=962eadc4&scoped=true&"
import script from "./MassMessageStatView.vue?vue&type=script&lang=ts&"
export * from "./MassMessageStatView.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageStatView.vue?vue&type=style&index=0&id=962eadc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962eadc4",
  null
  
)

export default component.exports